export const CategoryConstants = {
  LTO: 'LTOs',
};
